import { ROLE, VisibleFilters } from './interfaces';

export enum HIERARCHY_OPTIONS {
  AGENCY = 'AGENCY',
  ADM = 'ADM',
  FPR = 'FPR',
  ZM = 'ZM'
}

export enum TIMEFRAME {
  HOUR = 'HOUR',
  DAY = 'DAY'
}

export const DPD_BUCKET_OPTIONS_FOR_FILTER = [
  {
    label: 'DPD 31 - 60',
    value: 'BUCKET_1'
  },
  {
    label: 'DPD 61 - 90',
    value: 'BUCKET_2'
  },
  {
    label: 'DPD 91 - 180',
    value: 'BUCKET_3'
  },
  {
    label: 'DPD 180+',
    value: 'BUCKET_4'
  }
];

export const HIERARCHY_FILTERS_OPTIONS = [
  {
    label: 'Agency',
    value: HIERARCHY_OPTIONS.AGENCY
  },
  {
    label: 'ADM',
    value: HIERARCHY_OPTIONS.ADM
  },
  {
    label: 'FPR',
    value: HIERARCHY_OPTIONS.FPR
  },
  {
    label: 'ZM',
    value: HIERARCHY_OPTIONS.ZM
  }
];

export const roleFilterConfig: Record<
  ROLE,
  (aggregationLevel: HIERARCHY_OPTIONS) => VisibleFilters
> = {
  ADM: () => ({
    showHierarchyLevelOneFilter: true,
    showHierarchyLevelTwoFilter: false,
    showHierarchyLevelThreeFilter: false
  }),

  FPR: aggregationLevel => ({
    showHierarchyLevelOneFilter: true,
    showHierarchyLevelTwoFilter: aggregationLevel === HIERARCHY_OPTIONS.AGENCY,
    hierarchyLevelTwoFilterType: HIERARCHY_OPTIONS.ADM,
    showHierarchyLevelThreeFilter: false
  }),

  ZM: aggregationLevel => {
    const selectedADM = aggregationLevel === HIERARCHY_OPTIONS.ADM;
    const selectedAgency = aggregationLevel === HIERARCHY_OPTIONS.AGENCY;

    const showHierarchyLevelTwoFilter = selectedADM || selectedAgency;
    const hierarchyLevelTwoFilterType = HIERARCHY_OPTIONS.FPR;

    const showHierarchyLevelThreeFilter = showHierarchyLevelTwoFilter && selectedAgency;
    const hierarchyLevelThreeFilterType = HIERARCHY_OPTIONS.ADM;

    return {
      showHierarchyLevelOneFilter: true,
      showHierarchyLevelTwoFilter,
      hierarchyLevelTwoFilterType,
      showHierarchyLevelThreeFilter,
      hierarchyLevelThreeFilterType
    };
  }
};

export const tabOptions = [
  { label: 'Hourly', value: TIMEFRAME.HOUR },
  { label: 'Daily', value: TIMEFRAME.DAY }
];
